import React from 'react';
import PropTypes from 'prop-types';

import {ComponentError} from '../../ComponentError/ComponentError';

import './FallbackUI.less';

export const FallbackUI = ({errorText, title}) => (
    <div className="FallbackUI rounded-border">
        <ComponentError errorText={errorText} loading={false} title={title} />
    </div>
);

FallbackUI.Proptypes = {
    errorText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};
